import React from 'react';
import PropTypes from 'prop-types';
import FertilizerIcon from 'assets/fertilizer.svg';
import SeedsIcon from 'assets/seeds.svg';
import ServiceIcon from 'assets/service.svg';
import SprayIcon from 'assets/spray.svg';
import { productTypes } from 'components/ProductSideBar/helpers/constants';

const ProductTypeDisplay = ({ productType, iconSize }) => {
  if (productType == null) return null;

  const productTypeString = productTypes.find(
    ({ key }) =>
      productType.localeCompare(key, undefined, { sensitivity: 'accent' }) === 0
  )?.value;

  let productTypeIcon;
  switch (productType.toUpperCase()) {
    case 'SEED':
      productTypeIcon = SeedsIcon;
      break;
    case 'SERVICE':
      productTypeIcon = ServiceIcon;
      break;
    case 'FERTILIZER':
      productTypeIcon = FertilizerIcon;
      break;
    default:
      productTypeIcon = SprayIcon;
  }

  return (
    <>
      <img
        width={iconSize}
        className="mr-1"
        src={productTypeIcon}
        alt="product type icon"
      />
      {productTypeString}
    </>
  );
};

ProductTypeDisplay.propTypes = {
  productType: PropTypes.string,
  iconSize: PropTypes.number
};

ProductTypeDisplay.defaultProps = {
  productType: undefined,
  iconSize: 18
};

export default ProductTypeDisplay;
